import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';

import Grid from '@material-ui/core/Grid';
import { ValidatorForm } from 'react-material-ui-form-validator';

import { getEmailConfig, sendEmailConfig } from '../../store/actions';

import { EmailConfigToGet } from '../../models/interfaces';

import theme from '../../../../styles/theme';
import { Container, IButton, InputText, ButtonSend } from '../../../../styles/styles';
import { Typography } from '@material-ui/core';

const INITIAL_EmailConfig: EmailConfigToGet = {
  subjectNewDocuments: '',
  messageNewDocuments: '',
  subjectDocumentsWillExpire: '',
  messageDocumentsWillExpire: '',
  subjectDocumentsExpired: '',
  messageDocumentsExpired: '',
  subjectChargeDefault: '',
  messageChargeDefault: '',
}

const EmailConfig: React.FC = () => {
  const [EmailMessages, setEmailMessages] = useState<EmailConfigToGet>(INITIAL_EmailConfig);

  useEffect(() => {
    emailConfig();
  }, [])

  const emailConfig = async () => {
    getEmailConfig().then((res: EmailConfigToGet) => {
      setEmailMessages(res);
    })
    .catch(err => {
      console.log(err);
      Swal.fire({
        title: 'Erro',
        text: `Ocorreu algum erro ao carregar os dados.`,
        icon: 'error',
        showConfirmButton: false,
        timer: 2000
      });
    });
  };

  const handleSubmit = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    event.preventDefault();

    if (File) {
      Swal.fire({
        title: 'Aguarde...',
        text: 'Salvando configurações',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: async () => {
          Swal.showLoading();

          const emailsConfig: EmailConfigToGet = {
            subjectNewDocuments: EmailMessages.subjectNewDocuments.trim(),
            messageNewDocuments: EmailMessages.messageNewDocuments.trim(),
            subjectDocumentsWillExpire: EmailMessages.subjectDocumentsWillExpire.trim(),
            messageDocumentsWillExpire: EmailMessages.messageDocumentsWillExpire.trim(),
            subjectDocumentsExpired: EmailMessages.subjectDocumentsExpired.trim(),
            messageDocumentsExpired: EmailMessages.messageDocumentsExpired.trim(),
            subjectChargeDefault: EmailMessages.subjectChargeDefault.trim(),
            messageChargeDefault: EmailMessages.messageChargeDefault.trim(),
          }
          
          const res = await sendEmailConfig(emailsConfig);

          if (res) {
            Swal.fire({
              title: 'Configuração salva',
              html: `Os assuntos e mensagens dos e-mails foram salvas com sucesso!`,
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: theme.palette.primary.main,
              confirmButtonText: 'OK'
            });
          } else {
            Swal.fire({
              title: 'Erro',
              text: `Ocorreu algum erro ao executar a ação.`,
              icon: 'error',
              showConfirmButton: false,
              timer: 2000
            });
          }
        }
      });
    }
    await emailConfig();
  }

  const handleInputValue = (event: React.ChangeEvent<HTMLSelectElement>, input: string) => {
    setEmailMessages({ ...EmailMessages, [input]: event.target.value });
  }

  return (
    <React.Fragment>
      <Container background="#E2E4E6">
        <div style={{ margin: 10 }}>
          Você pode utilizar as tags: <br />
          <ul>
            <li>
              <b>[documentos]</b> para mencionar os nomes dos documentos.
            </li>
            <li>
              <b>[fornecedor]</b> para mencionar o nome do fornecedor.
            </li>
          </ul>
        </div>
        <ValidatorForm onSubmit={(e: any) => handleSubmit(e)}>
          <Grid container>
          <Typography variant="h6" style={{ marginLeft: 10, marginTop: 20, fontWeight: 'bold' }}>Mensagem padrão</Typography>
            <Grid item xs={12}>
              <InputText
                label="Assunto para cobrança Padrão"
                type="text"
                value={EmailMessages?.subjectChargeDefault}
                fullWidth
                multiline
                rows={5}
                rowsMax={5}
                variant="filled"
                onChange={(e: any) => handleInputValue(e, "subjectChargeDefault")}
                validators={['required']}
                errorMessages={['Campo obrigatório']}
              />
            </Grid>
            <Grid item xs={12}>
              <InputText
                label="Mensagem para cobrança padrão."
                type="text"
                value={EmailMessages?.messageChargeDefault}
                fullWidth
                multiline
                rows={5}
                rowsMax={5}
                variant="filled"
                onChange={(e: any) => handleInputValue(e, "messageChargeDefault")}
                validators={['required']}
                errorMessages={['Campo obrigatório']}
              />
            </Grid>
            <Typography variant="h6" style={{ marginLeft: 10, marginTop: 20, fontWeight: 'bold' }}>Novos Documentos</Typography>
            <Grid item xs={12}>
              <InputText
                label="Assunto para novos documentos"
                type="text"
                value={EmailMessages?.subjectNewDocuments}
                fullWidth
                multiline
                rows={5}
                rowsMax={5}
                variant="filled"
                onChange={(e: any) => handleInputValue(e, "subjectNewDocuments")}
                validators={['required']}
                errorMessages={['Campo obrigatório']}
              />
            </Grid>
            <Grid item xs={12}>
              <InputText
                label="Mensagem para novos documentos"
                type="text"
                value={EmailMessages?.messageNewDocuments}
                fullWidth
                multiline
                rows={5}
                rowsMax={5}
                variant="filled"
                onChange={(e: any) => handleInputValue(e, "messageNewDocuments")}
                validators={['required']}
                errorMessages={['Campo obrigatório']}
              />
            </Grid>
            <Typography variant="h6" style={{ marginLeft: 10, marginTop: 20, fontWeight: 'bold' }}>Documentos a Vencer</Typography>
            <Grid item xs={12}>
              <InputText
                label="Assunto para documentos a vencer"
                type="text"
                value={EmailMessages?.subjectDocumentsWillExpire}
                fullWidth
                multiline
                rows={5}
                rowsMax={5}
                variant="filled"
                onChange={(e: any) => handleInputValue(e, "subjectDocumentsWillExpire")}
                validators={['required']}
                errorMessages={['Campo obrigatório']}
              />
            </Grid>
            <Grid item xs={12}>
              <InputText
                label="Mensagem para documentos a vencer"
                type="text"
                value={EmailMessages?.messageDocumentsWillExpire}
                fullWidth
                multiline
                rows={5}
                rowsMax={5}
                variant="filled"
                onChange={(e: any) => handleInputValue(e, "messageDocumentsWillExpire")}
                validators={['required']}
                errorMessages={['Campo obrigatório']}
              />
            </Grid>
            <Typography variant="h6" style={{ marginLeft: 10, marginTop: 20, fontWeight: 'bold' }}>Documentos Vencidos</Typography>
            <Grid item xs={12}>
              <InputText
                label="Assunto para documentos vencidos"
                type="text"
                value={EmailMessages?.subjectDocumentsExpired}
                fullWidth
                multiline
                rows={5}
                rowsMax={5}
                variant="filled"
                onChange={(e: any) => handleInputValue(e, "subjectDocumentsExpired")}
                validators={['required']}
                errorMessages={['Campo obrigatório']}
              />
            </Grid>
            <Grid item xs={12}>
              <InputText
                label="Mensagem para documentos vencidos"
                type="text"
                value={EmailMessages?.messageDocumentsExpired}
                fullWidth
                multiline
                rows={5}
                rowsMax={5}
                variant="filled"
                onChange={(e: any) => handleInputValue(e, "messageDocumentsExpired")}
                validators={['required']}
                errorMessages={['Campo obrigatório']}
              />
            </Grid>
            <Grid item xs={12}>
              <ButtonSend>
                <IButton width={130} background="#52D126" type="submit" style={{ marginRight: 10 }}>SALVAR</IButton>
              </ButtonSend>
            </Grid>
          </Grid>
        </ValidatorForm>
      </Container>
    </React.Fragment>
  )
}

export default EmailConfig;
